import { Conversation } from '~/views/alfred/research/use-chat/use-chat.types';

export interface PollingTarget {
  conversationId: string;
  taskId: string;
}

export const getInProgressConversations = (
  conversations: Conversation[]
): PollingTarget[] =>
  conversations.reduce<PollingTarget[]>((targets, conv) => {
    if (conv.status !== 'Processing') {
      return targets;
    }

    const lastTask = conv.tasks?.[conv.tasks.length - 1];

    if (lastTask) {
      targets.push({
        conversationId: conv.id,
        taskId: lastTask.request_id,
      });
    }

    return targets;
  }, []);
